import React from "react";
import * as Scrivito from "scrivito";
import cx from "classnames";
import { useTranslate } from "hooks";
import { SideBarWrapper } from "components/LeftSidebar/SideBarWrapper";
import { ProductListLeftSidebar } from "objs/_ConfiguratorObjs/ProductList/ProductListLeftSidebar/ProductListLeftSidebar";
import { ProductConfiguratorLeftSidebarItem } from "./ProductConfiguratorLeftSidebarItem";

import s from "./ProductConfiguratorLeftSidebar.module.scss";
import { useProductName } from "stores/product";
import { MENU_ITEMS } from "./variables";

export const ProductConfiguratorLeftSidebar = Scrivito.connect(() => {
  const translate = useTranslate();
  const productName = useProductName();

  return (
    <SideBarWrapper
      width={300}
      classNames="sideBarWidth"
      withToggle
      isFirstSidebar
      toggleText="LEFT_SIDEBAR_PRODUCT_MENU"
      isRightSidebarToggle={false}
    >
      <div
        className="h-full-exclude-footer bg-gray-700"
        style={{ width: `${300}px` }}
      >
        <div className="d-flex flex-column h-full">
          <div className="ps-1 bg-gray-700 w-100">
            <div className={cx("pb-4 border-bottom", s.productsNavigation)}>
              <div className="d-flex flex-column gap-1 ps-4 py-3">
                <h3
                  className="text-uppercase mb-0 text-white fw-500 text-truncate"
                  title={productName ?? ""}
                >
                  {productName}
                </h3>
                <h6 className="text-uppercase text-white fw-normal mb-0">
                  {translate("PRODUCT_CONFIGURATOR_CONFIGURATION")}
                </h6>
              </div>
              {MENU_ITEMS.map((item) => (
                <ProductConfiguratorLeftSidebarItem
                  key={item.tab}
                  item={item}
                />
              ))}
            </div>
          </div>
          <ProductListLeftSidebar isModalActive={false} />
        </div>
      </div>
    </SideBarWrapper>
  );
});
